const toastService = {
    messages: [],
    subscribers: [], // Array to hold callback functions
  
    // Subscribe to changes
    subscribe(callback) {
      this.subscribers.push(callback);
      return () => {
        this.subscribers = this.subscribers.filter((cb) => cb !== callback);
      };
    },
  
    // Notify all subscribers of a change
    notify() {
      this.subscribers.forEach((callback) => callback());
    },
  
    add({ severity = 'info', summary, detail, life = 3000 }) {
      const id = Math.random().toString(36).substr(2, 9);
      this.messages = [...this.messages, { id, severity, summary, detail, life }];
      // console.log('Toast added:', { id, severity, summary, detail, life });
      this.notify(); // Notify subscribers after adding a toast
      if (life > 0) {
        setTimeout(() => {
          this.messages = this.messages.filter((msg) => msg.id !== id);
          // console.log('Toast removed:', id);
          this.notify(); // Notify subscribers after removing a toast
        }, life);
      }
    },
  
    remove(id) {
      this.messages = this.messages.filter((msg) => msg.id !== id);
      // console.log('Toast removed:', id);
      this.notify(); // Notify subscribers after removing a toast
    },
  
    getMessages() {
      return this.messages;
    },
  };
  
  export default toastService;